import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertWarning, BodyText } from '@kallidus/common';
import { string } from 'prop-types';

export const INVALID_CREDENTIALS = '455';
export const TOO_MANY_INVALID_ATTEMPTS = '458';
export const INVALID_VERIFICATION_CODE = 'Invalid Code';

export const LoginFormError = ({ errorCode = '' }) => {
  const { t } = useTranslation();
  return (
    <>
      {errorCode === INVALID_CREDENTIALS && <AlertWarning>{t('auth.errors.invalid-login-attempt')}</AlertWarning>}
      {errorCode === TOO_MANY_INVALID_ATTEMPTS && (
        <AlertWarning>
          <BodyText noTopSpacer>{t('auth.errors.too-many-login-attempts-line-1')}</BodyText>
          <BodyText>{t('auth.errors.too-many-login-attempts-line-2')}</BodyText>
          <BodyText>{t('auth.errors.too-many-login-attempts-line-3')}</BodyText>
        </AlertWarning>
      )}
      {errorCode === INVALID_VERIFICATION_CODE && <AlertWarning>{t('auth.errors.invalid-code')}</AlertWarning>}
    </>
  );
};

LoginFormError.propTypes = {
  errorCode: string,
};
